require('./inc/site.js');

var feedbacksContent = undefined;
var moreFeedbackBtn = undefined;
var feedbacks = [{
  'name': "T. Elek",
  'description': "Nagyon szuper, gyors, pontos, tökéletes!"
}];

$(document).ready(function(){
    feedbacksContent = $.find('[data-purpose="feedbacks-content"]');
    moreFeedbackBtn = $.find('[data-purpose="more-feedback"]');

    if (moreFeedbackBtn && moreFeedbackBtn.length > 0 && feedbacksContent && feedbacksContent.length == 1)
    {
      $(moreFeedbackBtn).click(function(){
        loadFeedbacks();
      });
    }
});

/** Nem tudom, hogy ajax-olni szeretnétek, vagy json-ből rajzoltatni, esetleg már betöltéskör kirajzolni,
 * és rejteni. Ha nem lesz több vélemény, akkor hide-oljuk a további linket.
 *
*/
function loadFeedbacks()
{
  writeFeedbacks(feedbacks);
  $(moreFeedbackBtn).parent().hide(200);
}

function writeFeedbacks(feedbacks)
{
  if (feedbacks && feedbacks.length > 0) {
    for (var i = 0; i < feedbacks.length; i++) {
      var content = $('<div>', {
        'class': 'feedback-box',
      });

      content.append('<svg class="icon quotation-mark"><use xlink:href="#quotation-mark" /></svg>');
      content.append('<div class="description">'+feedbacks[i].description+'</div>');
      content.append('<div class="name">'+feedbacks[i].name+'</div>');

      $(feedbacksContent).append(content);
    }
  }
}

